<template>
    <ul class="products-aside">
        <li v-for="(item, index) in products" :key="index">
            <a :href="`#${$parent.getId(item.name)}`">{{item.name}}</a>
        </li>
    </ul>
</template>

<script>
export default {
    props: ['products'],
}
</script>

<style lang="scss">
    .products-aside{
        li{
            width: 95%;
            margin-bottom: 10px;
            background-color: rgba(246,252,255,1);
            cursor: pointer;

            a{
                display: block;
                padding: 10px 20px;
                transition: all 0.3s;

                &:hover{
                    padding-left: 30px
                }
            }
        }
    }
</style>